import axios from 'axios';
import get from 'lodash/get';
import { integrations as integrationsCatalog } from '../../libs/statusCatalog';

// Libs
import { thunkHandler, thunkErrorHanlder} from '../../libs/utils';

// Endpoints
import {
  INTEGRATION,
  PAYMENT_INSTRUCTIONS_INT,
  SAT_INTEGRATION,
  DOWNLOAD_INVOICES,
  SPEI_INTEGRATION,
  SAT_INTEGRATION_ERRORS,
  API_KEY,
  STRIPE_INTEGRATION,
  OXXO_INTEGRATION,
  CONEKTA_INTEGRATION,
  CONTPAQI_INTEGRATION,
  CONTPAQI_INTEGRATION_V2,
  RELATION_CONCEPTS,
  SAVE_RELATION_CONCEPTS,
  FISERV_INTEGRATION,
  INTEREST_INTEGRATION,
  SAP_BUSINESS_ONE,
  OYSTER_INTEGRATION,
  NEW_FISERV_INTEGRATION
} from '../../constants/endpoints';

// Actions
export const NEW_INTEGRATION_SAT_DATA = 'NEW_INTEGRATION_SAT_DATA';
export const NEW_INTEGRATION_SAT_DOWNLOADS = 'NEW_INTEGRATION_SAT_DOWNLOADS'
export const NEW_INTEGRATION_SAT_ERRORS = 'NEW_INTEGRATION_SAT_ERRORS';
export const NEW_PAYMENT_INSTRUCTIONS_DATA = 'NEW_PAYMENT_INSTRUCTIONS_DATA';
export const NEW_SPEI_DATA = 'NEW_SPEI_DATA';
export const NEW_STRIPE_DATA = 'NEW_STRIPE_DATA';
export const NEW_INTEGRATIONS_STATE = 'NEW_INTEGRATIONS_STATE';
export const NEW_API_KEY = 'NEW_API_KEY';
export const NEW_OXXO_DATA = 'NEW_OXXO_DATA';
export const NEW_CONEKTA_DATA = 'NEW_CONEKTA_DATA';
export const NEW_CONTPAQI_DATA = 'NEW_CONTPAQI_DATA';
export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION';
export const GET_RELATION_CONCEPTS = 'GET_RELATION_CONCEPTS'
export const SEND_RELATION_CONCEPTS = 'SEND_RELATION_CONCEPTS'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const NEW_FISERV_INTEGRATION_DATA = 'NEW_FISERV_INTEGRATION_DATA'
export const NEW_INTEREST_INTEGRATION_DATA = 'NEW_INTEREST_INTEGRATION_DATA';
export const UPDATE_INTEREST_INTEGRATION_DATA = 'UPDATE_INTEREST_INTEGRATION_DATA';
export const NEW_SAP_INTEGRATION_DATA= 'NEW_SAP_INTEGRATION_DATA';
export const GET_STP_INTEGRATION= 'GET_STP_INTEGRATION';
/*
#######################################
##### SAT DOWNLOAD PUBLIC ACTIONS #####
#######################################
*/

export function getDownloadIntegration() {
  return dispatch => axios.get(DOWNLOAD_INVOICES)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DOWNLOADS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END getDownloadIntegration

export function integrateDownloads(body) {
  return dispatch => axios.post(DOWNLOAD_INVOICES, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DOWNLOADS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END integrationDownloads

export function updateDownloadIntegration(body) {
  return dispatch => axios.put(DOWNLOAD_INVOICES, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DOWNLOADS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END updateDownloadIntegration

export function deleteDownloadIntegration() {
  return dispatch => axios.delete(DOWNLOAD_INVOICES)
    .then(() => dispatch({ type: NEW_INTEGRATION_SAT_DOWNLOADS, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END deleteDownloadIntegration

/* 
##################################
##### CONEKTA PUBLIC ACTIONS #####
################################## 
*/

export function getConektaIntegration() {
  return dispatch => axios.get(CONEKTA_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONEKTA_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END getConektaIntegration

export function integrateConekta(body) {
  return dispatch => axios.post(CONEKTA_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONEKTA_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END integrateConekta

export function updateConektaIntegration(body) {
  return dispatch => axios.put(CONEKTA_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONEKTA_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END updateConektaIntegration
 
export function deleteConektaIntegration() {
  return dispatch => axios.delete(CONEKTA_INTEGRATION)
    .then(() => dispatch({ type: NEW_CONEKTA_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END deleteConektaIntegration

/* 
########################
##### OXXO ACTIONS #####
########################
*/

export function getOxxoIntegration() {
  return dispatch => axios.get(OXXO_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_OXXO_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END getOxxoIntegration

export function integrateOxxo(body) {
  return dispatch => axios.post(OXXO_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_OXXO_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END integrateOxxo

export function updateOxxoIntegration(body) {
  return dispatch => axios.put(OXXO_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_OXXO_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END updateOxxoIntegration

export function deleteOxxoIntegration() {
  return dispatch => axios.delete(OXXO_INTEGRATION)
    .then(() => dispatch({ type: NEW_OXXO_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END deleteOxxoIntegration

/*
##########################
##### STRIPE ACTIONS #####
##########################
*/

export function getStripeIntegration() {
  return dispatch  => axios.get(STRIPE_INTEGRATION)
  .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_STRIPE_DATA, 'ERROR'))
  .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} //END getStripeIntegration

export function integrateStripe(body) {
  return dispatch  => axios.post(STRIPE_INTEGRATION, body)
  .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_STRIPE_DATA, 'ERROR'))
  .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} //END integrateStripe

export const integrateStripeData = (data) => {
  return {
    type: NEW_STRIPE_DATA,
    payload: data
  }
};

export function updateStripeIntegration(body) {
  return dispatch  => axios.put(STRIPE_INTEGRATION, body)
  .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_STRIPE_DATA, 'ERROR'))
  .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} //END updateStripeIntegration

export function deleteStripeIntegration() {
  return dispatch => axios.delete(STRIPE_INTEGRATION)
    .then(() => dispatch({ type: NEW_STRIPE_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
} //END deleteStripeIntegration

/* ##############################
#### USER PROFILE ACTIONS
############################## */
export function getIntegrationsStates() {
  function parseIntegrationsStates(data){
    const states = { states: data };
    const receivedIntegrationIds = new Set(data.map(integration => integration.integration_id));

    data.forEach(integration => {
      const { integration_id } = integration;
      if (integration_id !== 3) {
        const integrationMeta = integrationsCatalog.getIntegration(integration_id);
        states[integrationMeta.name] = integration;
      }
    });

    if (!receivedIntegrationIds.has(16)) states.payfac = null;
    if (data.length === 0) states.sat_downloads = null;

    return states

  } // END

  return dispatch  => axios.get(INTEGRATION)
    .then(res => thunkHandler(dispatch, parseIntegrationsStates(get(res, 'data.data', [])), NEW_INTEGRATIONS_STATE, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getIntegrationsStates

/*
######################################
###### SAT CERTS PUBLIC ACTIONS ######
######################################
*/

export function getIntegrationSat() {
  return dispatch  => axios.get(SAT_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getIntegrationSat

export function integrateSat(body) {
  return dispatch  => axios.post(SAT_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END integrateSat

export function updateIntegrationSat(body) {
  return dispatch  => axios.put(SAT_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateIntegrationSat

export function deleteIntegrationSat() {
  return dispatch  => axios.delete(SAT_INTEGRATION)
    .then(() => dispatch({ type: NEW_INTEGRATION_SAT_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END deleteIntegrationSat

/*
##################################
###### CONTPAQI INTEGRATION ######
##################################
*/

export function getContpaqiIntegration() {
  return dispatch => axios.get(CONTPAQI_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTPAQI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END getContpaqiIntegration

export function integrateContpaqi(body) {
  return dispatch => axios.post(CONTPAQI_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTPAQI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END integrateContpaqi

export function getContpaqiV2Integration() {
  return dispatch => axios.get(CONTPAQI_INTEGRATION_V2)
    .then(res => {
      res.data.data.is_enabled = Object.keys(res.data.data).length ? 1 : 0
      thunkHandler(dispatch, res.data.data, NEW_CONTPAQI_DATA, 'ERROR')
    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
}

export function integrateContpaqiV2(body) {
  return dispatch => axios.post(CONTPAQI_INTEGRATION_V2, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTPAQI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END integrateContpaqi

export function updateContpaqiIntegration(body) {
  return dispatch => axios.put(CONTPAQI_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTPAQI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END updateContpaqiIntegration

export function deleteContpaqiIntegration() {
  return dispatch => axios.delete(CONTPAQI_INTEGRATION)
    .then(() => dispatch({ type: NEW_CONTPAQI_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END deleteContpaqiIntegration

export function getRelationConcepts() {
  return dispatch => axios.get(RELATION_CONCEPTS)
    .then(res => thunkHandler(dispatch, res.data.data.relation_concepts, GET_RELATION_CONCEPTS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
}

export function saveRelationConcepts(body) {
  return dispatch => axios.post(SAVE_RELATION_CONCEPTS, body)
    .then(res => thunkHandler(dispatch, res, SEND_RELATION_CONCEPTS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
}

export function toggleLoading(status) {
  return dispatch => thunkHandler(dispatch, status, TOGGLE_LOADING, 'ERROR')
}

// ##### END CONTPAQI INTEGRATION ######

export function getSatIntegrationsErrors(){
  return dispatch  => axios.get(SAT_INTEGRATION_ERRORS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'),NEW_INTEGRATION_SAT_ERRORS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

}

export function getPaymentInstructions() {
  return dispatch  => axios.get(PAYMENT_INSTRUCTIONS_INT)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PAYMENT_INSTRUCTIONS_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getIntegrationSat


export function updatePaymentInstructions(body) {
  return dispatch  => axios.put(PAYMENT_INSTRUCTIONS_INT, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PAYMENT_INSTRUCTIONS_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateIntegrationSat


export function getSpeiData() {
  return dispatch  => axios.get(OYSTER_INTEGRATION)
    .then(res => {
      const speiId = get(res, 'data.data.integration_id', 0);
      const data = get(res, 'data.data');
      return thunkHandler(dispatch, speiId === 12 ? data : {is_enabled: 0}, NEW_SPEI_DATA, 'ERROR')
    })
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
      dispatch({type: NEW_SPEI_DATA, payload: {is_enabled: 0}})
    });

} // END getSpeiData

export const getNewSpeiData = (data) => {
  return dispatch => {
    dispatch({type: NEW_SPEI_DATA, payload: data})
  }
}

export function integrateSpei(body) {
  const options = { headers: { 'content-type': 'application/json' } };
  return dispatch  => axios.post(SPEI_INTEGRATION, body, options)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SPEI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSpeiData

export function updateSpeiData(body) {
  return dispatch  => axios.put(SPEI_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SPEI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateSpeiData

export function deleteSpeiIntegration() {
  return dispatch  => axios.delete(OYSTER_INTEGRATION)
    .then(() => getSpeiData())
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSpeiData

export function getLastApiKey() {
  return dispatch  => axios.get(API_KEY)
    .then(res => thunkHandler(dispatch, get(res, 'data.data.access_token'), NEW_API_KEY, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSpeiData

export function newApiKey() {
  return dispatch  => axios.post(API_KEY)
    .then(res => thunkHandler(dispatch, get(res, 'data.data.access_token'), NEW_API_KEY, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSpeiData

/**
* Actualiza la integración que se pase como argumento
* @param  {string} integration   Integración que se va actualizar
* @param  {object} newAttributes Nuevos atributos de la integración
* @return {function}             Acción de redux
*/
export function manualUpdateIntegration(integration, newAttributes) {
  return dispatch => Promise.resolve(dispatch({
    type: UPDATE_INTEGRATION,
    payload:{integration, newAttributes}
  }));
} // END manualUpdateIntegration

/**
 * ##########################
 * FISERV Integration Actions
 * ##########################
 */
 export function getFiservIntegration() {
  return dispatch  => axios.get(FISERV_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_FISERV_INTEGRATION_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function createFiservIntegration(body) {
  return dispatch  => axios.put(NEW_FISERV_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_FISERV_INTEGRATION_DATA, 'ERROR'))
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
      const dataError = get(error, 'response.data');
      const phoneError = get(dataError, 'errors', {});
      if (dataError && dataError.key === 'integrations.creation_wallet_invalid_credentials.error') {
        return 'Las llaves son incorrectas, confirme y vuelva a intentarlo.';
      } else if (dataError && dataError.key === 'integrations.creation_wallet.error') {
        return 'Error inesperado, vuelve a intentar más tarde.';
      } else if (dataError && phoneError['customer.phone.number']) {
        return 'Para conectar tu cuenta Fiserv, es necesario completar los datos de tu empresa.'
      }
    });
}

export function deleteFiservIntegration() {
  return dispatch  => axios.delete(FISERV_INTEGRATION)
    .then(() => dispatch({ type: NEW_FISERV_INTEGRATION_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}


export function getInterestIntegration() {
  return dispatch =>
    axios
      .get(INTEREST_INTEGRATION)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEREST_INTEGRATION_DATA, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function putInterestIntegration(body) {
  return dispatch =>
    axios
      .put(INTEREST_INTEGRATION,body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEREST_INTEGRATION_DATA, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function patchInterestActive(uuid,body) {
  return dispatch =>
    axios
      .patch(`${INTEREST_INTEGRATION}/${uuid}`, body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), UPDATE_INTEREST_INTEGRATION_DATA, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

/**
 * ##########################
 * SAP Business One Actions
 * ##########################
 */

export function createSapIntegration(body) {
  return dispatch  => axios.post(SAP_BUSINESS_ONE, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SAP_INTEGRATION_DATA, 'ERROR'))
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
    });
}
export function getSapIntegration() {
  return dispatch  => axios.get(SAP_BUSINESS_ONE)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SAP_INTEGRATION_DATA, 'ERROR'))
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
    });
}

export function putSapIntegration(body) {
  return dispatch  => axios.put(SAP_BUSINESS_ONE, body)
    .then(res => thunkHandler(dispatch, get(res, 'data'), NEW_SAP_INTEGRATION_DATA, 'ERROR'))
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
    });
}

export function deleteSapIntegration() {
  return dispatch  => axios.delete(SAP_BUSINESS_ONE)
    .then(() => dispatch({ type: NEW_SAP_INTEGRATION_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export const getStpIntegration = () => {
  return async dispatch => {
    try {
      const resp = await axios.get(SPEI_INTEGRATION);
      dispatch({
        type: GET_STP_INTEGRATION,
        payload: { data: resp.data.data }
      });
    } catch (error) {
      dispatch({
        type: GET_STP_INTEGRATION,
        payload: { data: null }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/integrationsActions.js